import type { DropAnimation } from '@dnd-kit/core'
import { arrayMove } from '@dnd-kit/sortable'
import type { OrderingChoice } from './hooks'

export const ORDERING_DROP_ANIMATION = {
  duration: 250,
  easing: 'ease',
} satisfies DropAnimation

/**
 * Mouse movement must be intentional before a drag starts, so a click is not
 * consumed as a reorder gesture.
 */
export const ORDERING_MOUSE_ACTIVATION_CONSTRAINT = {
  distance: 4,
} as const

/**
 * Touch uses a short hold with movement tolerance. This lets an immediate
 * vertical swipe keep scrolling the page, while a held item can be reordered
 * on iPad and Android tablets.
 */
export const ORDERING_TOUCH_ACTIVATION_CONSTRAINT = {
  delay: 180,
  tolerance: 8,
} as const

export function reorderOrderingChoices(
  choices: OrderingChoice[],
  activeId: string,
  overId: string,
): OrderingChoice[] {
  const oldIndex = choices.findIndex(choice => choice.key === activeId)
  const newIndex = choices.findIndex(choice => choice.key === overId)

  if (oldIndex < 0 || newIndex < 0 || oldIndex === newIndex) {
    return choices
  }

  return arrayMove(choices, oldIndex, newIndex)
}
